// extracted by mini-css-extract-plugin
export default {"negative":"Balance_negative__7UmoQ","positive":"Balance_positive__kwjsn","background":"Balance_background__zFZxc"};